import cn from 'classnames';

interface SpacerProps {
  className?: string;
}

export const Spacer = ({ className }: SpacerProps) => (
  <div
    className={cn('tw-my-4 tw-h-[1px] tw-rounded tw-bg-blue-200', className)}
  />
);
